import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SiteCookies, SiteStorage, SiteText } from '@constants/global';
import { NotificationService } from '@services/notification.service';
import { UserService } from '@services/user.service';
import { UtilityService } from '@services/utility.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private user: UserService, private router: Router, private utility: UtilityService, private notification: NotificationService){}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(this.user.isLoggedIn()){
        return true;
      }else{
        this.utility.setInBrowserStorage(SiteStorage.RETURNURL, state.url);
        if(this.utility.getCookie(SiteCookies.ACCESSTOKEN) || this.utility.getCookie(SiteCookies.REFRESHTOKEN)){
          this.utility.deleteTokens();
        }
        this.router.navigate(['/']);
        this.notification.showNotification('error', SiteText.SESSION_ERROR);
        return false;
      }
    
  }
  
}
